export const REPLACEMENT_MAPPINGS = {
  default: {
    patient: 'patient',
    patients: 'patients',
    book: 'book',
    booking: 'booking',
    booked: 'booked',
    appointment: 'appointment',
    'getting scanned': 'getting scanned',
  },
  australia: {
    book: 'reserve',
    booking: 'reservation',
    booked: 'reserved',
  },
  researchOnly: {
    patient: 'participant',
    patients: 'participants',
    book: 'enroll',
    booking: 'enrolling',
    booked: 'enrolled',
    appointment: 'visit',
    'getting scanned': 'enrolling',
  },
};